const ViewMap = (props) => {
    const handleRouteClick = (e) => {
        if (props.disabled) {
            e.preventDefault(); // Prevent action if disabled
            return;
        }
        props.onClickShowRoute(props);
    };

    return (
        <a
            onClick={handleRouteClick}
            title={props.disabled ? "View Route (Disabled)" : "View Route"}
            style={{ pointerEvents: props.disabled ? "none" : "auto", opacity: props.disabled ? 0.5 : 1 }} // Disable click and adjust opacity when disabled
        >
            <i className="icofont icofont-map-pins f17"></i>
        </a>
    );
};

export default ViewMap;
